// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

export type rmaReturnEmail = {
    RMAEmail: string;
};

export const DispatchRmaReturnEmail: Handler<rmaReturnEmail> = props => {
    props.dispatch({
        type: "xRmaReturnInformation/SetRmaEmail",
        RMAEmail: props.parameter.RMAEmail,
    } as any);
};

const xSetRmaReturnEmail = createHandlerChainRunner([DispatchRmaReturnEmail], "rmaUPSReturnInformation");
export default xSetRmaReturnEmail;
